<template>
  <div id="home-badge">
    <!-- HTML HERE -->
    <div class="home-overlay"></div>

    <div id="home-overlay-con">
      <img src="../../assets/img/logo-home-screen.png" alt="Logo Psybooks" />
      <h2>{{ hOne }}<br />{{ hTwo }}</h2>

      <p>{{ pOne }}<br />{{ pTwo }}</p>

      <div class="cta-addto-homescreen">
        <a href="#" class="" @click.prevent="emit('yes')">{{ aOne }}</a>
      </div>
      <div class="user-cta-option">
        <a href="#" class="dont-ask" @click.prevent="emit('dont_ask')">{{
          aTwo
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hOne: String,
    hTwo: String,
    pOne: String,
    pTwo: String,
    aOne: String,
    aTwo: String,
    aThree: String
  },
  methods: {
    emit(answer) {
      this.$emit("sendAnswer", answer);
    }
  }
};
</script>

<style scoped>
/* CSS HERE */
#home-badge {
  width: 100%;
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 99999;
}
.home-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
}
#home-overlay-con {
  background: #fff;
  max-width: 80%;
  margin: 20px auto;
  border-radius: 10px;
  position: relative;
  z-index: 99999;
  padding: 20px 0;
}
#home-overlay-con img {
  width: 80px;
  margin: 15px auto;
  display: block;
}
#home-overlay-con h2 {
  margin: 20px auto 0;
  font-size: 20px;
  text-align: center;
  line-height: 24px;
}
#home-overlay-con p {
  margin: 20px auto;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  max-width: 70%;
}
.cta-addto-homescreen {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
}
.cta-addto-homescreen a {
  color: #5888c5;
  font-size: 24px;
  display: block;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
}
.cta-addto-homescreen a:hover {
  color: #d26d13;
}
.user-cta-option {
  padding: 10px 20px;
  margin: 10px 0;
}
.user-cta-option a {
  display: flex;
  justify-content: center;
  width: 100%;
  color: #000;
  font-size: 14px;
  font-weight: bold;
}
.user-cta-option a.dont-ask {
  float: left;
}

.user-cta-option a:hover {
  color: #d26d13;
}
</style>
